import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStackPlus16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconImageStackPlus16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 9a4 4 0 0 1-4-4H3a1 1 0 0 0-1 1v3.316l2.732-1.738.338-.215.284.283 5.191 5.192A1 1 0 0 0 11 12zm2-.535q-.466.27-1 .409V11a1 1 0 0 0 1-1zm1-.82A4 4 0 0 0 8.354 2H5a2 2 0 0 0-2 2.001 2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h7q.171 0 .335-.028a.5.5 0 0 0 .58-.193A2 2 0 0 0 12 12a2 2 0 0 0 2-2zM7.535 3H5a1 1 0 0 0-1 1h3.126q.138-.534.41-1M11 3a.57.57 0 0 0-.571.571v.858H9.57a.571.571 0 0 0 0 1.142h.858v.858a.571.571 0 1 0 1.143 0V5.57h.857a.571.571 0 0 0 0-1.142h-.857V3.57A.57.57 0 0 0 11 3m-9 7.48V12a1 1 0 0 0 1 1h6.293L4.93 8.637l-2.804 1.785a.5.5 0 0 1-.126.057"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStackPlus16);
